import { render, staticRenderFns } from "./unified-insights.vue?vue&type=template&id=1aa7325a&"
import script from "./unified-insights.vue?vue&type=script&lang=tsx&"
export * from "./unified-insights.vue?vue&type=script&lang=tsx&"
import style0 from "./unified-insights.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports